import { faEdit, faSearch, faTrash, faCheck, faAdd } from "@fortawesome/free-solid-svg-icons"

export const table_translate = {
    body: {
        emptyDataSourceMessage: 'Sem dados para exibir',
        deleteText: 'Tem de que deseja excluir esta linha?',
        emptyDataSourceMessage: 'Sem dados para exibir',
        addTooltip: 'Adicionar',
        deleteTooltip: 'Deletar',
        editTooltip: 'Editar',
        filterRow: {
            filterPlaceHolder: 'Filtrar',
            filterTooltip: 'Filtrar',
        },
        editRow: {
            deleteText: 'Tem certeza de que deseja excluir?',
            cancelTooltip: 'Cancelar',
            saveTooltip: 'Salvar',
        },
    },
    grouping: {
        placeholder: 'Arraste o título da coluna para agrupar as linhas',
        groupedBy: 'Agrupar por: ',
    },
    header: {
        actions: '',
    },
    pagination: {
        labelDisplayedRows: '{count} de {from}-{to}',
        labelRowsSelect: 'linhas',
        labelRowsPerPage: 'Linhas por página: ',
        firstAriaLabel: 'Primeira página',
        firstTooltip: 'Primeira página',
        previousAriaLabel: 'Página anterior',
        previousTooltip: 'Página anterior',
        nextAriaLabel: 'Próxima página',
        nextTooltip: 'Próxima página',
        lastAriaLabel: 'Última página',
        lastTooltip: 'Última página',
    },
    toolbar: {
        addRemoveColumns: 'Adicionar ou remover colunas',
        nRowsSelected: '{0} linhas(s) selecionadas',
        showColumnsTitle: 'Mostrar colunas',
        showColumnsAriaLabel: 'Mostrar colunas',
        exportTitle: 'Exportar',
        exportAriaLabel: 'Exportar',
        exportName: 'Exportar como CSV',
        searchTooltip: 'Pesquisar',
        searchPlaceholder: 'Pesquise aqui...',
    },
}

export const table_style =
{
    headerStyle: {
        fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
        fontWeight: '700',
        color: '#888',
    },
    textLabels: {
        body: {
            noMatch: "Nenhum registro encontrado",
            toolTip: "Ordenar",
            columnHeaderTooltip: column => `Ordenar por ${column.label}`
        },
        pagination: {
            next: "Próximo",
            previous: "Anterior",
            rowsPerPage: "Linhas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Pesquisar",
            downloadCsv: "Download CSV",
            print: "Imprimir",
            viewColumns: "Visualizar colunas",
            filterTable: "Filtrar tabela",
        },
        filter: {
            all: "Todos",
            title: "FILTROS",
            reset: "RESTAURAR",
        },
        viewColumns: {
            title: "Mostrar colunas",
            titleAria: "Mostrar/Esconder colunas",
        },
        selectedRows: {
            text: "linha(s) selecionas",
            delete: "Apagar",
            deleteAria: "Apagar linhas selecionadas",
        },
    }
}
export const actionsTable = {
    visualizar: (onClick) => {
        return {
            icon: faSearch,
            tooltip: 'Visualizar Registro',
            color: "bg-gradient bg-primary text-light",
            iconProps: { style: { ...actionStyle, backgroundColor: "#2980b9" } },
            onClick: (event, rowData) => onClick(rowData)
        }
    },
    editar: (onClick) => {
        return {
            icon: faEdit,
            tooltip: 'Editar Registro',
            color: "bg-gradient bg-warning text-light",
            iconProps: { style: { ...actionStyle, backgroundColor: "#f39c12" } },
            onClick: (event, rowData) => onClick(rowData)
        }
    },
    adicionar: (onClick) => {
        return {
            icon: faAdd,
            tooltip: 'Adicionar Registro',
            color: "bg-gradient bg-primary text-light",
            iconProps: { style: { ...actionStyle, backgroundColor: "#2980b9" } },
            onClick: (event, rowData) => onClick(rowData)
        }
    },
    remover: (onClick) => {
        return {
            icon: faTrash,
            tooltip: 'Remover Registro',
            color: "bg-gradient bg-danger text-light",
            iconProps: {
                style: { ...actionStyle, backgroundColor: "#c0392b" }
            },
            onClick: (event, rowData) => onClick(rowData)
        }
    },
    confirmar: (onClick) => {
        return {
            icon: faCheck,
            tooltip: 'Confirmar',
            color: "bg-gradient bg-info text-light",
            iconProps: { style: { ...actionStyle, backgroundColor: "#27ae60" } },
            onClick: (event, rowData) => onClick(rowData)
        }
    }
}
export const actionStyle = {
    width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "5px", color: "white"
}
